import { render } from "./AppButton.vue?vue&type=template&id=3cddfcda&scoped=true&ts=true"
import script from "./AppButton.vue?vue&type=script&lang=ts"
export * from "./AppButton.vue?vue&type=script&lang=ts"

import "./AppButton.vue?vue&type=style&index=0&id=3cddfcda&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cddfcda"]])

export default __exports__